import { AdState } from '@/models/ad';

export const config: Record<
  AdState,
  { textColor: string; bgColor: string; dotColor: string; labelKey: string }
> = {
  RUNNING: {
    bgColor: 'bg-emerald-100',
    textColor: 'text-emerald-700',
    dotColor: 'bg-emerald-500',
    labelKey: 'state.running',
  },
  PAUSED: {
    bgColor: 'bg-indigo-100',
    textColor: 'text-indigo-600',
    dotColor: 'bg-indigo-500',
    labelKey: 'state.paused',
  },
  STOPPED: {
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-600',
    dotColor: 'bg-purple-500',
    labelKey: 'state.stopped',
  },
  DELETED: {
    bgColor: 'bg-gray-200',
    textColor: 'text-gray-700',
    dotColor: 'bg-gray-700',
    labelKey: 'state.deleted',
  },
  PENDING: {
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-600',
    dotColor: 'bg-orange-500',
    labelKey: 'state.pending',
  },
  EXHAUSTED: {
    bgColor: 'bg-red-100',
    textColor: 'text-red-600',
    dotColor: 'bg-red-500',
    labelKey: 'state.exhausted',
  },
  NONE: {
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-600',
    dotColor: 'bg-gray-500',
    labelKey: 'state.none',
  },
};
